/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getSavingsBalance} from '../api'

 export const useQueryGetSavingsBalance = createReactQueryHook('getSavingsBalance', getSavingsBalance)
